import { useNavigate, useParams } from "react-router-dom";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { useConsultarVeiculoPorChassi } from "../../../hooks/queries/veiculo/useConsultarVeiculoPorChassi/useConsultarVeiculoPorChassi";
import { useContextSite } from "../../../context/Context";
import { Tracking } from "../../../services/Tracking";
import { IFormBuscarVeiculoPorChassiValues } from "../../Molecules/FormBuscarVeiculoV2/useFormBuscarVeiculoV2";

export const useLicenseV2 = () => {
  const navigate = useNavigate();
  const { uuidAgendamento } = useParams();
  const stepIndicator = useAgendamentoStepIndicator();
  const { setIsLoad } = useContextSite();
  const { mutate: consultarVeiculo } = useConsultarVeiculoPorChassi();

  function handleSubmit(data: IFormBuscarVeiculoPorChassiValues) {
    setIsLoad(true);
    consultarVeiculo(
      {
        Chassi: data.chassi,
        uuidAgendamento,
      },
      {
        onSuccess: ({ data: veiculo }) => {
          navigate(
            `/agendamento/${uuidAgendamento}/servicos/veiculo?uuidVeiculo=${veiculo.uuid}`,
          );
        },
        onError: ({
          response: {
            data: { mensagem },
          },
        }: any) => {
          Tracking.error(
            "mapa:agendamento/servicos/emplacamento:consultar-veiculo-falhou",
            { mensagem },
          );
        },
        onSettled: () => setIsLoad(false),
      },
    );
  }

  return { stepIndicator, handleSubmit };
};
